import styled from 'styled-components';

interface ICardProps {
    borderTop?: boolean;
}

export const Card = styled.div<ICardProps>`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-top: ${props => props.borderTop ? '1px solid #ddd' : 'none'};
    align-items: flex-start;
`;

export const LeftContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const RightContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
`;

export const Title = styled.div`
    display: flex;
    font-weight: bold;
`;

export const Details = styled.div`
    display: flex;
    font-size: 0.9em;
`;

export const CreatedAt = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const CreatedBy = styled.div`
    display: flex;
    justify-content: flex-end;
`;